import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { cloneDeep } from 'lodash';
import { StrideReviewActions } from '../../stride-review-store';
import { StrideReviewService } from '../services/stride-review.service';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@Injectable()
export class StrideReviewEffects {
  constructor(
    private actions$: Actions,
    private strideReviewService: StrideReviewService
  ) {}

  loadSingleStrideReview$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StrideReviewActions.loadSingleStrideReview),
      switchMap(({ reviewDataBlob }) => {
        if (reviewDataBlob) {
          return this.strideReviewService.getReviewData(reviewDataBlob).pipe(
            mergeMap((review) => {
              const strideReviewData = cloneDeep(review) as any;
              if (
                strideReviewData.filteredKeypoints ||
                strideReviewData.reasons
              ) {
                return [
                  StrideReviewActions.addSingleStrideReview(),
                  StrideReviewActions.addStrideFilteredKeyPointsItem({
                    strideFilteredKeyPoints: strideReviewData.filteredKeypoints,
                  }),
                  StrideReviewActions.addStrideReasonsDetailItemList({
                    strideReasonsList: strideReviewData.reasons,
                  }),
                ];
              }
              return EMPTY;
            }),
            catchError(() => EMPTY)
          );
        } else {
          return EMPTY;
        }
      })
    );
  });
}
